import { BankDetailsParams } from '../../BankDetails';

// Common dynamic data shared by Bank Detail events
export const getCommonDynamicData = (params: BankDetailsParams) => ({
  eventName: params.eventName,
  object: params.object,
  action: params.action,
  customerGroup: params.distributorId,
  productId: params.productId,
  customAttribute1: params.bankPage,
  customAttribute2: params.product_type
    ? `/dbs/v1/products/${params.productId}/${params.product_type}`
    : '',
  customAttribute5: params.interestRates.interest_rate_nominal
    ? `/dbs/v1/products/${params.productId}/interest_rates/${params.interestRates.interest_rate_nominal}`
    : '',
  customAttribute6: params.interestRates.interest_rate_effective
    ? `/dbs/v1/products/${params.productId}/interest_rates/${params.interestRates.interest_rate_effective}`
    : '',
  customAttribute7: params.bank_id
    ? `/dbs/v1/deposits/${params.productId}/product/deposit_taking_bank/${params.bank_id}`
    : '',
});
